import { APP_BASE_HREF } from '@angular/common';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigurationService } from 'mbs-ui-shared@services/configuration.service';
import { EnvironmentService } from 'mbs-ui-shared@services/environments.service';
import { Observable } from 'rxjs';
import { convertToClientUrl, removeDoubleSlash } from '../pipes';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
  private appBaseHref = inject(APP_BASE_HREF);
  private configurationService = inject(ConfigurationService);
  private environment = inject(EnvironmentService);

  private excludeUrls: (string | any)[];

  constructor() {
    this.excludeUrls = ['https://foris.cloudberrylab.com', 'api/odata/mbs/providerSignIn'];
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let newUrl = removeDoubleSlash(req.url);

    const excludeUrls: Array<string> = this.excludeUrls.concat(
      this.configurationService.loaded
        ? [
            this.configurationService.get('rmmBaseHref'),
            this.configurationService.get('rmmBaseSignalRHref'),
            this.configurationService.get('rmmScriptLibraryHref'),
            this.configurationService.get('rmmCustomSettings'),
            this.configurationService.get('licensesHref'),
            this.configurationService.get('appsBaseHref'),
            this.configurationService.get('deepInstinctHref'),
            this.configurationService.get('ticketsUrl'),
            this.configurationService.get('rmmWarehouse'),
            this.configurationService.get('assetsUrl'),
            this.configurationService.get('documentsUrl')
          ]
        : []
    );

    if (this.environment.production && excludeUrls.every((url) => !newUrl.includes(url))) {
      newUrl = `${location.origin}` + convertToClientUrl(newUrl, this.appBaseHref);
    }

    req = req.clone({ url: removeDoubleSlash(newUrl), headers: req.headers.set('X-Requested-With', 'XMLHttpRequest') });

    return next.handle(req);
  }
}
